import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import axios from "axios";
import { marked } from 'marked';
import Title from 'context/title';
import "./legal.css";

class Page extends Component {
  constructor(props) {
    super(props);

    // Three states, not two. `content` null with `failed` false is "the fetch has not answered
    // yet", and it renders NOTHING — rendering the error there would flash a failure notice on
    // every load of a page that is about to succeed.
    this.state = {
      content: null,
      failed: false
    };
  }

  componentDidMount() {
    Title.set(this.title());
    // The fetch belongs here, not in the constructor: a constructor that starts I/O is a side
    // effect in a function React is allowed to call without ever mounting the result, and the
    // resulting setState lands on a component that was never committed.
    this.loadContent();
  }

  // Default hook for subclasses that forget to override it. Title.set(null) drops the part and
  // falls through to Title.setRoot(), so a missing title() degrades to "BlobHub" instead of
  // throwing in componentDidMount and blanking the page.
  title() {
    return null;
  }

  loadContent() {
    axios.get(this.contentPath())
      .then( response => {
        this.setState({ content: {__html: marked.parse(response.data)}, failed: false });
      }, error => {
        // The handler used to be empty, which left `content` null forever and rendered an empty
        // <Col> — a blank page on exactly the documents you would later need to show were
        // published. A legal page that cannot be fetched must say so and offer a way to ask for
        // the text.
        this.setState({ failed: true });
      });
  }

  renderError() {
    return (
      <div className="legal-error" role="alert">
        <h1>{this.title()}</h1>
        <p>
          This document could not be loaded. It may be a temporary network problem — reloading the
          page usually fixes it.
        </p>
        <p className="mb-0">
          If it keeps happening, ask us for a copy at{" "}
          <a href="mailto:legal@blobhub.io">legal@blobhub.io</a> and we will send you the current
          version.
        </p>
      </div>
    );
  }

  renderContent() {
    // WHY THIS IS NOT A SANITISER GAP. The HTML comes from marked.parse() over a document this
    // repository authored: `public/static/legal/*.md`, deployed beside the bundle and fetched from
    // this app's own origin. No user, and nobody outside the origin, can put a byte into it — the
    // input is a build artifact, not content. A sanitiser here would guard a channel that carries
    // nothing but our own text.
    //
    // Both halves of that are load-bearing. Point contentPath() at another origin, or let anyone
    // but a deploy write those files, and this needs DOMPurify (already a dependency) before it
    // ships. See "Out of scope" in docs/specs/2026-09-08-legal-documents-rewrite.md.
    return <div dangerouslySetInnerHTML={this.state.content}/>;
  }

  render() {
    return (
      <>
        <Container className="blob-header-row content-row">
          <Row>
            <Col className="legal-content">
              {this.state.failed ? this.renderError() : (this.state.content ? this.renderContent() : null)}
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

export class Cookies extends Page {
  contentPath() {
    return "/static/legal/cookies.md";
  }

  title() {
    return "Cookie Policy";
  }
}

export class Terms extends Page {
  contentPath() {
    return "/static/legal/terms.md";
  }

  title() {
    return "Terms of Use";
  }
}

export class Privacy extends Page {
  contentPath() {
    return "/static/legal/privacy.md";
  }

  title() {
    return "Privacy Policy";
  }
}

export class Beta extends Page {
  contentPath() {
    return "/static/legal/beta.md";
  }

  title() {
    return "Beta Terms and Conditions";
  }
}
